var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission__deny__component"},[_c('div',{staticClass:"permission__deny__component-content"},[_c('h2',{staticClass:"permission__deny__component-content-title text-danger font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t("validation.access_denied"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }